@if (!isMobile) {
    <div class="bin-analytics-container">
        <div class="header-container-wrapper">
            <div class="title-container">
                {{ 'TITLES.ANALYTICS' | translate }}                  
            </div>
        </div>
        <div class="bin-metrics-container">
            <div class="bin-metrics-container-kpis">
                <div class="metrics-item-container">
                    <circle-progress class="circle-progress"
                        [percent]="usageType == 1 ? selectedBinInfo?.Bin_live_Data.average_daily_usage_rate_in_percent : selectedBinInfo?.Bin_live_Data.average_daily_fill_rate_in_liters"
                        [maxPercent]="100"
                        [toFixed]="0"
                        [showTitle]="false"
                        [showUnits]="false"
                        [showSubtitle]="false"
                        [showInnerStroke]="true"
                        [animation]="false"
                        [outerStrokeGradient]="false"
                        [radius]="75"
                        [outerStrokeColor]="'#4F8F6F'"
                        [innerStrokeWidth]="20"
                        [outerStrokeWidth]="20"      
                        [innerStrokeColor]="'#E9E9E9'"
                        [space]="-20">
                    </circle-progress>
                    <div class="data-container">
                      <div class="text-number" rtlDiv>
                        @if (usageType == 1) {
                            {{selectedBinInfo?.Bin_live_Data.average_daily_usage_rate_in_percent | number:'1.0-2'}}%
                        }@else if (usageType == 2 && currentLang != 'iw') {
                            {{selectedBinInfo?.Bin_live_Data.average_daily_fill_rate_in_liters | number:'2.1-2'}} L
                        }@else if (usageType == 2 && currentLang == 'iw') {
                            {{selectedBinInfo?.Bin_live_Data.average_daily_fill_rate_in_liters | number:'2.1-2'}} ל
                        }
                      </div>
                      <div class="text-title" rtlDiv>
                        @if (usageType == 1) {
                            {{ 'LIVE_INFO.AVG_RATE' | translate }}
                        }@else if (usageType == 2) {
                            {{ 'LIVE_INFO.EMPTY_RATE' | translate }}
                        }
                      </div>
                    </div>
                </div>
                @if (usageType == 1) {
                    <div class="middle-divider"></div>
                    <div class="metrics-item-container">
                        <circle-progress class="circle-progress"
                            [percent]="selectedBinInfo?.Bin_live_Data.average_collections_capacity_in_percent"
                            [maxPercent]="100"
                            [toFixed]="0"
                            [showTitle]="false"
                            [showUnits]="false"
                            [showSubtitle]="false"
                            [showInnerStroke]="true"
                            [animation]="false"
                            [outerStrokeGradient]="false"
                            [radius]="75"
                            [outerStrokeColor]="'#4F8F6F'"
                            [innerStrokeWidth]="20"
                            [outerStrokeWidth]="20"      
                            [innerStrokeColor]="'#E9E9E9'"
                            [space]="-20">
                        </circle-progress>
                        <div class="data-container">
                          <div class="text-number" rtlDiv>
                            {{selectedBinInfo?.Bin_live_Data.average_collections_capacity_in_percent?.toFixed()}}%
                          </div>
                          <div class="text-title" rtlDiv>
                            {{ 'LIVE_INFO.AVG_COL_CAP' | translate }}
                          </div>
                        </div>
                    </div>
                }
            </div>
            <div class="bin-metrics-container-kpis">
                @if(usageType == 1){
                    <div class="metrics-item-container">
                        <img src="assets/images/binInfoPage/max_days.svg" alt="" />
                        <div class="data-container">
                            <div class='text-number'>
                                @if(selectedBinInfo?.Bin_thresholds.max_days_between_collections != 0) {
                                    {{selectedBinInfo?.Bin_thresholds.max_days_between_collections}} {{'COLLECTION_REPORT.DAYS' | translate }}
                                }@else if(selectedBinInfo?.Bin_thresholds.max_days_between_collections == 0) {
                                    {{ 'LIVE_INFO.UNLIMITED' | translate }}
                                }
                            </div>
                            <div class='text-title' rtlDiv>{{ 'MANAGE_BIN.MAX_DAYS' | translate }}</div>
                        </div>
                    </div>
                    <div class="middle-divider"></div>
                    <div class="metrics-item-container">
                        <img src="assets/images/binInfoPage/max_allowed.svg" alt="" />
                        <div class="data-container">
                          <div class="text-number" rtlDiv>{{selectedBinInfo?.Bin_thresholds.bin_max_allowed_fill_level_in_percent}}%</div>
                          <div class="text-title" rtlDiv>{{ 'MANAGE_BIN.MAX_CAPACITY' | translate }}</div>
                        </div>
                    </div>
                    <div class="middle-divider"></div>
                    <div class="metrics-item-container">
                        <img src="assets/images/binInfoPage/collection_frequency.svg" alt="" />
                        <div class="data-container">
                          <div class="text-number" rtlDiv>{{selectedBinInfo?.Bin_live_Data.bin_collection_or_refill_rate?.toFixed(0)}} {{'COLLECTION_REPORT.DAYS' | translate }}</div>
                          <div class="text-title" rtlDiv>{{ 'MANAGE_BIN.MONTHLY_COLLECTION_FREQ' | translate }}</div>
                        </div>
                    </div>
                }       
            </div>
        </div>
    </div>
}

@if (isMobile) {

}